import { createDomain } from 'effector-root';

const domain = createDomain('Products (Page)');

export const onPageStarted = domain.event();